export const cropDetailsData = {
  paddy: {
    id: "paddy",
    title: "Paddy",
    titleKey: "crop_paddy",
    heroImage: "https://images.unsplash.com/photo-1596489317585-6baef7cfa5f0?auto=format&fit=crop&q=80&w=2000",
    packages: [
      {
        name: "Majorsol Paddy",
        description: "High performance soil application fertilizer. Helps to increase disease resistance power in crop.",
        packSize: "5 kg/ 10 kg",
        contents: [
          "Zinc as Zn :10.0%",
          "Sulphur as S : 8.0%",
          "Potassium as K2O :13.0%",
          "Phosphorus as P2O5 : 20.0%",
          "Boron as B : 0.5%",
          "Magnesium Mg : 2.0%"
        ],
        productLink: "#"
      }
    ],
    diseases: [
      {
        name: "Zinc Deficiency",
        symptoms: "Yellowing of older leaves.",
        affect: "Growth was stunted.",
        solution: {
          product: "Macrofert 20:20:20 5gm/lit",
          soilDrip: "Plantex 20:20:20 5kg/acre",
          benefit: "Helps in vegetative growth, formation of amino acids"
        },
        recommendedProduct: "Macrofert",
        productLink: "#"
      },
      {
        name: "Phosphorous Deficiency",
        symptoms: "Reddish purplish colour of older leaves.",
        affect: "Premature leaf fall, reduce tillering in rice.",
        solution: {
          product: "Fertimax 12:61:00 5gm/lit, Fertimax 00:52:34 (5-10gm/lit)",
          soilDrip: "Plantex 12:61:00 5kg/acre",
          benefit: "Root development, winter hardness"
        },
        recommendedProduct: "Fertimax PK",
        productLink: "#"
      },
      {
        name: "Potassium Deficiency",
        symptoms: "Brown colour spots.",
        affect: "Growth is stunted, shortening of internodes.",
        solution: {
          product: "Chelamin plus 1-2gm/lit",
          soilDrip: "Chelamin gold 0.5kg/acre",
          benefit: "Helps in activation of enzymes"
        },
        recommendedProduct: "Chelamin plus",
        productLink: "#"
      }
    ]
  },
  // Add other crops following the same structure below
  sugarcane: {
    id: "sugarcane",
    title: "Sugarcane",
    titleKey: "crop_sugarcane",
    heroImage: "https://images.unsplash.com/photo-1596489317585-6baef7cfa5f0?auto=format&fit=crop&q=80&w=2000",
    packages: [],
    diseases: []
  }
};
